import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Grid,
  Link,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { fetchWeeklyMeetingConfig } from '../../../controllers/meetingsController';
import { getCurrencyDisplayLabel } from '../../../utils/currencyDisplay';

export const PAYMENTS_WEEKLY_MEETINGS_PATH = '/payments/weekly-meetings';

export const useWeeklyMeetingMealConfig = (active) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!active) return;
    setError('');
    setLoading(true);
    fetchWeeklyMeetingConfig()
      .then((data) => setConfig(data))
      .catch((e) => {
        setConfig(null);
        setError(e?.message || 'Yemek birim fiyatı alınamadı');
      })
      .finally(() => setLoading(false));
  }, [active]);

  const mealPrice =
    config?.defaultMealPrice != null && config.defaultMealPrice !== ''
      ? Number(config.defaultMealPrice)
      : null;
  const currency = config?.currency || 'TRY';

  return { config, loading, error, mealPrice, currency };
};

const MeetingMealPriceField = ({ loading, error, mealPrice, currency, textFieldSx = {} }) => {
  const priceDisplay =
    mealPrice != null && !Number.isNaN(mealPrice) ? String(mealPrice) : '';
  const currencyValue = currency || 'TRY';

  return (
    <Grid item xs={12} sm={6}>
      <Box>
        <Typography variant="body2" sx={{ mb: 0.6, fontWeight: 500 }}>
          Yemek Ücreti
        </Typography>
        {loading ? (
          <CircularProgress size={22} sx={{ my: 1 }} />
        ) : (
          <>
            <Box sx={{ display: 'flex', alignItems: 'stretch' }}>
              <TextField
                type="number"
                value={priceDisplay}
                fullWidth
                disabled
                placeholder={priceDisplay ? '' : 'Tanımlı değil'}
                sx={{
                  ...textFieldSx,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '5px 0 0 5px',
                    minHeight: 44,
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#e6e6e6',
                      borderRightWidth: 0,
                    },
                  },
                }}
              />
              <TextField
                select
                value={currencyValue}
                disabled
                sx={{
                  ...textFieldSx,
                  minWidth: 100,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '0 5px 5px 0',
                    minHeight: 44,
                    marginLeft: -1,
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderLeftWidth: 1,
                      borderLeftStyle: 'solid',
                      borderLeftColor: '#e6e6e6',
                    },
                  },
                }}
              >
                <MenuItem value="TRY">{getCurrencyDisplayLabel('TRY')}</MenuItem>
                <MenuItem value="USD">{getCurrencyDisplayLabel('USD')}</MenuItem>
                <MenuItem value="EUR">{getCurrencyDisplayLabel('EUR')}</MenuItem>
              </TextField>
            </Box>
            <Alert severity="warning" sx={{ mt: 1.25, fontSize: '13px', alignItems: 'flex-start' }}>
              {error ? (
                <>
                  {error}. Yemek ücretinde güncelleme yapmak için lütfen{' '}
                  <Link component={RouterLink} to={PAYMENTS_WEEKLY_MEETINGS_PATH} underline="hover">
                    Haftalık Toplantılar
                  </Link>{' '}
                  sayfasını ziyaret ediniz.
                </>
              ) : (
                <>
                  Yemek ücretinde güncelleme yapmak için lütfen{' '}
                  <Link component={RouterLink} to={PAYMENTS_WEEKLY_MEETINGS_PATH} underline="hover">
                    Haftalık Toplantılar
                  </Link>{' '}
                  sayfasını ziyaret ediniz.
                </>
              )}
            </Alert>
          </>
        )}
      </Box>
    </Grid>
  );
};

export default MeetingMealPriceField;
